import { render, staticRenderFns } from "./messageBoxList.vue?vue&type=template&id=ab227182"
import script from "./messageBoxList.vue?vue&type=script&lang=js"
export * from "./messageBoxList.vue?vue&type=script&lang=js"
import style0 from "./messageBoxList.vue?vue&type=style&index=0&id=ab227182&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports